import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Route from './router';
import SessionExpiryProvider from '@ms/shared/components/auth/session_expiry_provider';

const SESSION_TOKEN_KEYS = ['token'];
const LOGIN_PATHS = ['/', '/login', '/main_login'];

function App() {
  return (
    <SessionExpiryProvider tokenKeys={SESSION_TOKEN_KEYS} loginUrl="/login?logout=true" loginPaths={LOGIN_PATHS}>
      <Route />
    </SessionExpiryProvider>
  );
}

export default App;
